import { BUSINESS_HOURS, DAY_NAMES } from "../Aux/businessInfo";

/**
 * Get the current day number (0-6, where 0 is Sunday)
 */
export const getDayNumber = () => new Date().getDay();

/**
 * Get the current day name abbreviation
 */
export const getTodayName = () => DAY_NAMES[getDayNumber()];

/**
 * Check if the business is open today
 */
export const isOpenToday = () => {
    const dayNum = getDayNumber();
    return BUSINESS_HOURS.openDays.includes(dayNum);
};

/**
 * Check if the business is closed today
 */
export const isClosedToday = () => {
    const dayNum = getDayNumber();
    return BUSINESS_HOURS.closedDays.includes(dayNum);
};

/**
 * Get the current status text (e.g., "10a – 6p" or "Closed")
 */
export const getTodayStatus = () => {
    return isOpenToday()
        ? `${BUSINESS_HOURS.open.start} – ${BUSINESS_HOURS.open.end}`
        : BUSINESS_HOURS.closedDisplay;
};

/**
 * Check if the given day number is an open day
 */
export const isDayOpen = (dayNum) => BUSINESS_HOURS.openDays.includes(dayNum);

/**
 * Check if the given day number is a closed day
 */
export const isDayClosed = (dayNum) => BUSINESS_HOURS.closedDays.includes(dayNum);
